import errorMap from '@gap/backend/util/validations/validation-error-map'
import { z } from 'zod'

export const feedbackTypeEnum = [
   'prework-document-summary',
   'feedback-document-summary',
   'feedback-from-app-bar',
   'meeting-deliverable',
   'feedback-from-meeting-workspace-banner',
   'meetings-workspace',
] as const
export const feedbackTypeEnumSchema = z.enum(feedbackTypeEnum, { errorMap })
export type FeedbackTypeEnum = z.output<typeof feedbackTypeEnumSchema>

export const feedbackRatingEnum = ['good', 'bad', 'not specified'] as const
export const feedbackRatingEnumSchema = z.enum(feedbackRatingEnum, { errorMap })
export type FeedbackRatingEnum = z.output<typeof feedbackRatingEnumSchema>

export enum FeedbackQuestionsEnum {
   whatWorkedWell = 'What worked well?',
   whatCouldBeImproved = 'What could be improved?',
   anythingElse = 'Anything else?',
   whatIsWorkingWell = 'What is working well?',
   anyOtherComments = 'Any other comments?',
}

export const feedbackQuestionsSchemaZod = z.object({
   whatWorkedWell: z.string({ errorMap }).optional(),
   whatCouldBeImproved: z.string({ errorMap }).optional(),
   anythingElse: z.string({ errorMap }).optional(),
})

export const feedbackQuestionsSchema: Record<FeedbackTypeEnum, (keyof typeof FeedbackQuestionsEnum)[]> = {
   'prework-document-summary': ['whatWorkedWell', 'whatCouldBeImproved', 'anythingElse'],
   'feedback-document-summary': ['whatWorkedWell', 'whatCouldBeImproved', 'anythingElse'],
   'feedback-from-app-bar': ['whatIsWorkingWell', 'whatCouldBeImproved', 'anyOtherComments'],
   'meeting-deliverable': ['whatCouldBeImproved'],
   'feedback-from-meeting-workspace-banner': ['whatIsWorkingWell', 'whatCouldBeImproved', 'anyOtherComments'],
   'meetings-workspace': ['whatIsWorkingWell', 'whatCouldBeImproved', 'anyOtherComments'],
}
